import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { FaArrowLeft } from "react-icons/fa";
import { API_BASE_URL } from "../config";

const ListingsHandover = () => {
  const { saleId } = useParams();
  const navigate = useNavigate();



  // ALWAYS pull fresh userId on every mount
  const [userId, setUserId] = useState(Number(localStorage.getItem("userId")));

  const [sale, setSale] = useState(null);
  const [loading, setLoading] = useState(true);
  const [handoverDelayDays, setHandoverDelayDays] = useState(7);

  /* ============================================================
     FORCE UPDATE USERID ON MOUNT
  ============================================================ */
 useEffect(() => {
  const idFromStorage = localStorage.getItem("userId");
  const parsedId = parseInt(idFromStorage, 10);

  console.log("LOCALSTORAGE USER ID:", idFromStorage, typeof idFromStorage);
  console.log("PARSED USER ID:", parsedId, typeof parsedId);

  setUserId(parsedId);
}, []);


  /* ============================================================
     LOAD SALE DETAILS
  ============================================================ */
  const loadSale = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/handover/${saleId}`);

      if (res.data.success) {
        setSale(res.data.sale);
        setHandoverDelayDays(
  res.data.handoverDelayDays !== undefined
    ? Number(res.data.handoverDelayDays)
    : 7
);
      }
    } catch (err) {
      console.error("Error loading sale:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSale();
  }, [saleId]);

  /* ============================================================
     BUTTON ACTIONS
  ============================================================ */

  const sellerConfirm = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/handover/seller-confirm`, {
        saleId,
      });

      alert("You have marked the handover as completed.");
      loadSale();
    } catch (err) {
      console.error(err);
    }
  };

  const buyerConfirm = async () => {
    try {
      await axios.post(`${API_BASE_URL}/api/handover/buyer-confirm`, {
        saleId,
      });

      alert("You have confirmed the handover.");
      loadSale();
    } catch (err) {
      console.error(err);
    }
  };

  if (loading) return <p>Loading...</p>;
  if (!sale) return <p>Sale not found.</p>;

  /* ============================================================
     DETERMINE WHO IS LOGGED IN
  ============================================================ */
  const isSeller = Number(sale.sellerId) === Number(userId);
const isBuyer = Number(sale.buyerId) === Number(userId);


  const sellerComplete = sale.handover_seller == 1;
  const buyerComplete = sale.handover_buyer == 1;

  const sellerHandoverAt = sale.handover_seller_at
  ? new Date(sale.handover_seller_at)
  : null;



const sevenDaysMs =
  handoverDelayDays * 24 * 60 * 60 * 1000;

const buyerCanConfirm =
  sellerHandoverAt &&
  Date.now() - sellerHandoverAt.getTime() >= sevenDaysMs;

const daysRemaining =
  sellerHandoverAt && !buyerCanConfirm
    ? Math.ceil(
        (sevenDaysMs - (Date.now() - sellerHandoverAt.getTime())) /
          (24 * 60 * 60 * 1000)
      )
    : 0;



  /* ============================================================
     BUTTON LOGIC
  ============================================================ */
  let actionButton = null;

  // Seller must confirm first
  if (isSeller && !sellerComplete) {
    actionButton = (
      <button
        onClick={sellerConfirm}
        style={btnStyleGreen}
      >
        Mark Handover Complete
      </button>
    );
  }

  // Buyer confirms after seller
if (isBuyer && sellerComplete && !buyerComplete) {
  actionButton = (
    <div>
      <button
        onClick={buyerConfirm}
        disabled={!buyerCanConfirm}
        style={
          buyerCanConfirm
            ? btnStyleBlue
            : {
                ...btnStyleBlue,
                backgroundColor: "#9e9e9e",
                cursor: "not-allowed",
                opacity: 0.75,
              }
        }
      >
        Confirm Handover
      </button>

      {!buyerCanConfirm && (
        <p
  style={{
    marginTop: "10px",
    textAlign: "center",
    color: "#666",
    fontSize: "14px",
  }}
>
  Buyer confirmation will become available in approximately{" "}
  <strong>{daysRemaining}</strong> day{daysRemaining === 1 ? "" : "s"}.
  This waiting period helps support a smooth and secure handover process between both parties.
</p>
      )}
    </div>
  );
}

  return (
    <div style={{ maxWidth: "900px", margin: "20px auto", padding: "10px" }}>
    

      <button onClick={() => navigate(-1)} style={backBtn}>
        <FaArrowLeft /> Back
      </button>

      <h2 style={{ textAlign: "center", color: "#2e7d32", marginBottom: "25px" }}>
        Client Handover
      </h2>

      {/* STATUS */}
      <div style={sectionStyle}>
        <h3>Handover Status</h3>
        <p>
          {!sellerComplete && "Seller must mark the handover as complete first."}
          {sellerComplete && !buyerComplete && "Waiting for buyer confirmation."}
          {sellerComplete && buyerComplete && "Handover complete."}
        </p>
         {/* ACTION BUTTON */}
      {actionButton}
      </div>

      {/* LISTING */}
      <div style={sectionStyle}>
        <h3>Listing Information</h3>
        <p><strong>Listing ID:</strong> {sale.listingId}</p>
        
        <p><strong>Suburb:</strong> {sale.suburb} {sale.postcode}</p>
        <p><strong>Price:</strong> ${sale.price}</p>
      </div>

      {/* PARTIES */}
<div style={sectionStyle}>
  <h3>Parties Involved</h3>

  <h4>Seller</h4>
  <p><strong>Name:</strong> {sale.seller_first} {sale.seller_last}</p>
  <p><strong>Email:</strong> {sale.seller_email || "N/A"}</p>
  <p><strong>Phone:</strong> {sale.seller_phone || "N/A"}</p>
  <p><strong>Company:</strong> {sale.seller_company || "N/A"}</p>
  <p><strong>ABN:</strong> {sale.seller_abn || "N/A"}</p>

  <hr style={{ margin: "20px 0" }} />

  <h4>Buyer</h4>
  <p><strong>Name:</strong> {sale.buyer_first} {sale.buyer_last}</p>
  <p><strong>Email:</strong> {sale.buyer_email || "N/A"}</p>
  <p><strong>Phone:</strong> {sale.buyer_phone || "N/A"}</p>
  <p><strong>Company:</strong> {sale.buyer_company || "N/A"}</p>
  <p><strong>ABN:</strong> {sale.buyer_abn || "N/A"}</p>
</div>


      {/* TIMELINE */}
      <div style={sectionStyle}>
        <h3>Timeline</h3>
        <p><strong>Seller Completed:</strong> {sellerComplete ? "Yes" : "Not yet"}</p>
        <p><strong>Buyer Confirmed:</strong> {buyerComplete ? "Yes" : "Not yet"}</p>
      </div>

     
    </div>
  );
};

/* Styles */
const sectionStyle = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  border: "1px solid #ccc",
  marginBottom: "20px",
};

const btnStyleGreen = {
  marginTop: "20px",
  backgroundColor: "#2e7d32",
  color: "white",
  border: "none",
  padding: "14px",
  borderRadius: "8px",
  width: "100%",
  fontSize: "16px",
  cursor: "pointer",
};

const btnStyleBlue = {
  marginTop: "20px",
  backgroundColor: "#1565c0",
  color: "white",
  border: "none",
  padding: "14px",
  borderRadius: "8px",
  width: "100%",
  fontSize: "16px",
  cursor: "pointer",
};

const backBtn = {
  padding: "8px 14px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
  display: "inline-flex",
  gap: "8px",
  alignItems: "center",
  marginBottom: "20px",
};

export default ListingsHandover;
